module.exports = __webpack_public_path__ + "img/verrière retour.3b504579.jpg";